import { Form as AntdForm, Select, Input, Spin } from 'antd'
import Flex from 'components/Flex'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import LabelInput from 'components/Form/LabelInput'
import InputText from 'components/Form/InputText'
import CrossIcon from 'components/icons/CrossIcon'
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`

const StyledSelect = styled(Select)`
  width: 100% !important;
  font-style: normal;
  font-weight: 500;
  font-size: ${props => (props.colorstyle ? '14px' : '16px')};
  line-height: 24px;
  color: ${props => (props?.color ? props?.color : '#010e30')};
  .ant-select-dropdown {
    background: red;
  }
  text-transform: ${props =>
    props.textTransformInitial ? 'initial' : 'capitalize'};

  .ant-select-selector {
    /* background-color: ${props =>
      !props.disabled
        ? props.backgroundcolor
          ? '#fafafb'
          : '#ffffff'
        : '#f5f5f5'} !important; */
    background-color: 'white';
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: ${props =>
      props.boxShadow ? props.boxShadow : 'none'} !important;
  }
  .ant-select-item-option-content {
    background: red;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
    border-radius: 6px;
    font-weight: ${props => props.colorstyle && '600'};
    color: ${props =>
      props?.selectedOptionColor
        ? props?.selectedOptionColor
        : !props.disabled && '#010e30'};
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
  }
  :hover {
    border-radius: 6px;
    color: #010e30;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    font-size: ${props => (props.colorstyle ? '14px' : '16px')};
    font-weight: 500;
    line-height: 24px;
  }
  .ant-select-selection-placeholder {
    text-transform: none !important;
  }

  .ant-select:hover .ant-select-clear {
    display: flex;
  }
`

const OTHERS_KEY = 'Others'

const DropDown = ({
  options = [],
  value,
  onChange,
  width = '100%',
  error,
  name,
  label,
  placeholder,
  optional = false,
  required = false,
  valueParam = 'id',
  nameParam = 'name',
  isOthers = false,
  position = 'relative',
  otherPlaceholder,
  otherLabel,
  isCombined = false,
  loading,
  id = 'select',
  onSearch,
  showSearch = false,
  isFilterOption = true,
  ...rest
}) => {

  const [showCustomInput, setShowCustomInput] = useState(false)

  const handleSelectChange = (val, option) => {
    if (val === OTHERS_KEY) {
      setShowCustomInput(true)
      onChange('', { isOthers: true })
    } else {
      setShowCustomInput(false)
      onChange(val, option)
    }
  }

  const handleMultiSelectChange = (val, optionList) => {
    const selectedPayloads = optionList
      .map(opt => opt?.props?.option)
      .filter(Boolean)
    onChange(val, selectedPayloads)
  }

  const filterOption = (input, option) => {
    if (!input) return
    const match = (options || []).some(opt =>
      String(opt[nameParam]).toLowerCase().includes(input.toLowerCase())
    )
    if (!match && isOthers) {
      return option.value === OTHERS_KEY
    }
    return String(option.children).toLowerCase().includes(input.toLowerCase())
  }

  const handleCustomInputChange = e => {
    const inputVal = e.target.value
    onChange(inputVal, { isOthers: true })
  }

  const combinedOptions = useMemo(() => {
    const validOptions = (options || []).filter(
      opt => opt[valueParam] !== null && opt[valueParam] !== undefined
    )
    const mapped = validOptions.map(opt => ({
      label: opt[nameParam],
      value: opt[valueParam],
      ...opt,
    }))
    return isOthers
      ? [...mapped, { label: 'Others', value: OTHERS_KEY }]
      : mapped
  }, [options, isOthers, valueParam, nameParam])

  return (
    <div name={name} key={name}>
      <Flex id={id} column style={{ width, position, gap: '0.5rem' }}>
        {label && (
          <LabelInput required={required}>
            {label} <span>{optional}</span>
          </LabelInput>
        )}
        <StyledSelect
          data-hasvalue={value && value !== '' ? 'true' : 'false'}
          width={width}
          name={name}
          size="large"
          suffixIcon={<SelectArrowIcon />}
          placeholder={placeholder}
          filterOption={isFilterOption ? filterOption : false}
          getPopupContainer={() => document.getElementById(id)}
          onChange={isCombined ? handleMultiSelectChange : handleSelectChange}
          value={
            showCustomInput ? OTHERS_KEY : value !== '' ? value : undefined
          }
          allowClear
          removeIcon={<CrossIcon />}
          options={combinedOptions}
          loading={loading}
          notFoundContent={loading && <Spin size="small" />}
          onSearch={onSearch}
          showSearch={showSearch}
          {...rest}
        />

        {showCustomInput && (
          <InputText
            onChange={handleCustomInputChange}
            style={{ marginTop: '8px' }}
            placeholder={otherPlaceholder}
            label={otherLabel}
          />
        )}

        {error && (
          <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>
        )}
      </Flex>
    </div>
  )
}

export default DropDown
